import { render, staticRenderFns } from "./studentEvolution.vue?vue&type=template&id=4c7ace1c&"
import script from "./studentEvolution.js?vue&type=script&lang=js&"
export * from "./studentEvolution.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports